import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import PropTypes from "prop-types";
import "./NetworkNodeTooltip.scss";
import Image from "antd/lib/image";
import Tooltip from "antd/lib/tooltip";
import Popover from "antd/lib/popover";
import verified from "../../../../../assets/verified.svg";
import BoostedPostIcon from "../../../../../assets/boosted_post_icon.svg";
import AdsPostIcon from "../../../../../assets/ads_post_icon.svg";
import Profile from "../../../../../assets/Profile_Pic.svg";
import userFollowers from "../../../../../assets/FollowersBlue.svg";
import ClockIcon from "../../../../../assets/Clock.svg";
import fx from "../../../../../assets/WidgetMaker/FX.svg";
import InfoIcon from "../../../../../assets/Info_Icon.svg";

import placeHolderImg from "../../../../../assets/placeholder_img.png";
import defaultImg from "../../../../../assets/WidgetMaker/Brocken_Image.svg";
import Default_Brand from "../../../../../assets/brandLogos/Default_Brand.svg";
import { SocialMedialogo } from "../../../../layout/DeepDive/DeepDivetab/SocialMediaPlatforms";
import {
  checkBackgroundIsDark,
  isScontentLinkExpire,
  kFormatter,
} from "../../../../../redux/constants";
import isEqual from "react-fast-compare";
import moment from "moment";
import { useSelector } from "react-redux";
import VideoPreview from "../../../../WidgetMaker/VideoPreview";
import Carousel from "../../../../WidgetMaker/Carousel";
import PostCardFooter from "../../../../WidgetMaker/PostCardFooter";
import SinglePostCard from "./PostCard/SinglePostCard";
import { getCSSVariableValue } from "../../../../../redux/constants/networkEnums";

const NetworkNodeTooltip = ({
  tooltipData,
  isTooltipShow,
  setIsTooltipShow,
  containerRef,
  PdfDownloadStatus,
  dashboard,
}) => {
  const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });
  const [bgColor, setBgColor] = useState(tooltipData?.node?.color?.background);
  const [arrowDirection, setArrowDirection] = useState("top");
  const [xTranslatePercent, setXTranslatePercent] = useState(50);
  const [yTranslatePercent, setYTranslatePercent] = useState(50);
  const tooltipContainerRef = useRef(null);
  const [refUpdated, setRefUpdated] = useState(false);

  // callback function got called when reference of tooltip is loaded
  const measuredTooltipRef = useCallback((node) => {
    if (node !== null) {
      tooltipContainerRef.current = node;
      setRefUpdated(!refUpdated);
    }
  }, []);
  const authParams = useSelector((state) => state?.Authentication?.authParams);
  const [isImage, setIsImage] = useState(false);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [videoPreview, setVideoPreview] = useState();
  const [isValidUrlFlag, setIsValidUrlFlag] = useState(null);
  // use when we need to show as per container with height
  // useEffect(() => {
  //   if (tooltipData && tooltipContainerRef?.current) {
  //     const tooltipRect = tooltipContainerRef?.current?.getBoundingClientRect();
  //     const chartContainerRect = containerRef?.current?.getBoundingClientRect();
  //     debugger;
  //     console.log("tooltipRect : ", tooltipRect);
  //     const tooltipWidth = tooltipRect?.width; // Assuming fixed width
  //     const tooltipHeight = tooltipRect?.height; // Assuming fixed height
  //     let newX = tooltipData?.canvasX;
  //     let newY = tooltipData?.canvasY;
  //     let newArrowDirection = "bottom";
  //     // Check if tooltip goes outside right boundary
  //     if (newX + tooltipWidth / 2 > chartContainerRect?.width) {
  //       newX = chartContainerRect?.width - tooltipWidth / 2;
  //     }
  //     // Check if tooltip goes outside left boundary
  //     if (newX - tooltipWidth / 2 < 0) {
  //       newX = tooltipWidth / 2;
  //     }
  //     // Check if tooltip goes outside bottom boundary
  //     if (newY + tooltipHeight > chartContainerRect?.height) {
  //       newY = tooltipData?.clientY - tooltipHeight - 20; // Adjust 2rem for arrow
  //       newArrowDirection = "top";
  //     }
  //     // Check if tooltip goes outside top boundary
  //     if (newY - tooltipHeight < 0) {
  //       newY = tooltipData?.clientY + 20; // Adjust 2rem for arrow
  //       newArrowDirection = "bottom";
  //     }
  //     setModalPosition({ x: newX, y: newY });
  //     setArrowDirection(newArrowDirection);
  //   }
  // }, [tooltipData, refUpdated, containerRef]);

  // used when need to show as per window width and height
  useEffect(() => {
    if (tooltipData) {
      const tooltipRect = tooltipContainerRef?.current?.getBoundingClientRect();
      // const chartContainerRect = containerRef?.current?.getBoundingClientRect();
      // console.log("tooltipRect : ", tooltipRect);
      const tooltipWidth = tooltipRect?.width || 0;
      const tooltipHeight = tooltipRect?.height || 0;
      let newX = tooltipData?.clientX || 0;
      let newY = tooltipData?.clientY || 0;
      let newArrowDirection = tooltipData?.node?.postCardDetails
        ? "right"
        : "top";
      // let updatedBgColor = tooltipData?.node?.postCardDetails
      //   ? "#ffffff"
      //   : tooltipData?.node?.color?.background;
      const primaryBgColor = getCSSVariableValue("--locobuzz-primary-bg-color");
      let updatedBgColor = tooltipData?.node?.postCardDetails
        ? primaryBgColor || "#ffffff"
        : primaryBgColor || "#ffffff";
      setBgColor(updatedBgColor);
      // Adjust newX and newY based on newArrowDirection
      if (newArrowDirection === "right") {
        // Calculate newX for right position
        newX = tooltipData?.clientX; // Adjust for padding // removing + 20

        // Check if tooltip goes outside right boundary
        if (newX + tooltipWidth > window?.innerWidth) {
          newX = tooltipData?.clientX - tooltipWidth; // Adjust for padding // removing - 20
          newArrowDirection = "left";
        }
        // Check if tooltip goes outside top boundary
        if (newY - tooltipHeight / 2 < 0) {
          let overflowHeight = newY - tooltipHeight / 2;
          newY = tooltipData?.clientY - overflowHeight;
          // setYTranslatePercent(100);
        } else if (newY + tooltipHeight / 2 > window?.innerHeight) {
          // Check if tooltip goes outside bottom boundary
          let overflowHeight = window?.innerHeight - (newY + tooltipHeight / 2);
          newY = window?.innerHeight + overflowHeight;
          setYTranslatePercent(100);
        }
      } else if (newArrowDirection === "top") {
        // Calculate newY for top position
        newY = tooltipData?.clientY - tooltipHeight; // Adjust for padding // removing - 20

        // Check if tooltip goes outside top boundary
        if (newY < 0) {
          newY = tooltipData?.clientY; // Adjust for padding // removing + 20
          newArrowDirection = "bottom";
        }

        // Check if tooltip goes outside right boundary
        if (newX + tooltipWidth / 2 > window?.innerWidth) {
          newX = window?.innerWidth - tooltipWidth / 2;
          setXTranslatePercent(0);
        } else if (newX - tooltipWidth / 2 < 0) {
          // Check if tooltip goes outside left boundary
          newX = tooltipWidth / 2;
          setXTranslatePercent(0);
        }
      }
      setModalPosition({ x: newX, y: newY });
      setArrowDirection(newArrowDirection);
    }
  }, [
    tooltipData,
    refUpdated,
    tooltipContainerRef?.current?.clientHeight,
    containerRef,
  ]);
  const closeModal = () => {
    setIsTooltipShow(false);
  };

  const getTextColor = (bgColor) => {
    const color = bgColor?.substring(1); // remove the '#'
    const rgb = parseInt(color, 16); // convert rrggbb to decimal
    const r = (rgb >> 16) & 0xff; // extract red
    const g = (rgb >> 8) & 0xff; // extract green
    const b = (rgb >> 0) & 0xff; // extract blue

    const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // calculate luma
    return luma > 160 ? "black" : "white"; // return white for dark backgrounds and black for light backgrounds
  };

  const isDarkBackground = useMemo(() => {
    return checkBackgroundIsDark(bgColor);
  }, [bgColor]);

  // console.log(
  //   "modalPosition : ",
  //   modalPosition,
  //   "arrowDirection : ",
  //   arrowDirection,
  //   "isDarkBackground : ",
  //   isDarkBackground,
  //   "bgColor : ",
  //   bgColor
  // );
  const getDefautBrandImg = (e) => {
    return (e.target.src = Default_Brand);
  };
  const onImageError = (e) => {
    if (e?.type === "error") {
      setIsImage(true);
    } else {
      setIsImage(false);
    }
    return (e.target.src = defaultImg);
  };
  const handleVideoPreview = (imgUrl) => {
    setIsVideoModalOpen(true);
    setVideoPreview(imgUrl?.MediaUrl);

    let isValidUrlFlag = isScontentLinkExpire(imgUrl?.MediaUrl, 1);
    setIsValidUrlFlag(isValidUrlFlag);
  };
  const getTooltipCardData = (data) => {
    let authorDetails = data?.node?.authorDetails;
    let postCardDetails = data?.node?.postCardDetails;
    if (postCardDetails) {
      return (
        <>
          <SinglePostCard
            postData={postCardDetails}
            backgroundColor={bgColor}
            color={data?.node?.color?.color}
            arrowDirection={arrowDirection}
            isDarkBackground={isDarkBackground}
          />
          {/* <div
            className={`node-modal-content postCardDetails`}
            style={{
              backgroundColor: bgColor,
              backgroundColor: bgColor,
              borderColor: data?.node?.color?.color,
            }}
          >
            <div
              className={`node-modal-arrow ${arrowDirection}`}
              style={
                arrowDirection === "top"
                  ? { borderTopColor: bgColor }
                  : arrowDirection === "bottom"
                  ? { borderBottomColor: bgColor }
                  : arrowDirection === "right"
                  ? { borderRightColor: bgColor }
                  : arrowDirection === "left"
                  ? { borderLeftColor: bgColor }
                  : ""
              }
            ></div>
            <div
              className={`node-modal-header border-0 postCardDetails__header ${
                postCardDetails?.SentimentType ? "pl-0" : ""
              }`}
            >
              {postCardDetails?.SentimentType ? (
                <div
                  style={{
                    borderLeft: `0.4rem solid ${
                      postCardDetails?.SentimentType === "Positive"
                        ? "#5ED142"
                        : postCardDetails?.SentimentType === "Negative"
                        ? "#FF5D48"
                        : postCardDetails?.SentimentType === "Neutral"
                        ? "#F0C52F"
                        : "black"
                    }`,
                    height: "3.6rem",
                    marginRight: "1rem",
                  }}
                ></div>
              ) : (
                ""
              )}
              {postCardDetails?.brand_logo &&
              postCardDetails?.BrandFriendlyName &&
              postCardDetails?.BrandFriendlyName !== "NA" &&
              postCardDetails?.BrandFriendlyName !== "" ? (
                <Popover
                  placement="leftBottom"
                  title={null}
                  content={
                    <div
                      style={{
                        maxWidth: "25rem",
                        maxHeight: "15rem",
                        overflow: "auto",
                        overflowWrap: "break-word",
                      }}
                      className="postCardDetails--brandname p-10"
                    >
                      {postCardDetails?.BrandFriendlyName}
                    </div>
                  }
                  overlayClassName={`postCardDetails__popover ${
                    isDarkBackground ? "darkTheme" : "lightTheme"
                  }`}
                >
                  <Image
                    src={
                      postCardDetails?.brand_logo
                        ? postCardDetails?.brand_logo
                        : Default_Brand
                    }
                    fallback={Default_Brand}
                    onError={getDefautBrandImg}
                    preview={false}
                    alt="Brand logo"
                    className="authorImg authorImg--profile mr-1 cursor-pointer"
                    // crossOrigin="anonymous"
                  />
                </Popover>
              ) : (
                <Image
                  src={
                    postCardDetails?.brand_logo
                      ? postCardDetails?.brand_logo
                      : Default_Brand
                  }
                  fallback={Default_Brand}
                  onError={getDefautBrandImg}
                  preview={false}
                  alt="Brand logo"
                  className="authorImg authorImg--profile mr-1 cursor-pointer"
                  // crossOrigin="anonymous"
                />
              )}

              <div
                className="position-relative mr-15"
                style={{ width: "3.5rem", height: "3.5rem" }}
              >
                <Popover
                  placement="leftBottom"
                  title={null}
                  content={
                    <div className="p-15 postCardDetails--bio">
                      {postCardDetails?.AuthorBio &&
                      postCardDetails?.AuthorBio !== "NA" &&
                      postCardDetails?.AuthorBio !== "" ? (
                        <div className="postCardDetails--bio--header font-weight500 w-100">
                          Bio
                        </div>
                      ) : (
                        ""
                      )}
                      <div
                        style={{
                          maxWidth: "25rem",
                          maxHeight: "15rem",
                          overflow: "auto",
                          overflowWrap: "break-word",
                        }}
                        className="custom_scroll1"
                      >
                        {postCardDetails?.AuthorBio &&
                        postCardDetails?.AuthorBio !== "NA" &&
                        postCardDetails?.AuthorBio !== "" ? (
                          <>{postCardDetails?.AuthorBio}</>
                        ) : (
                          <div className="d-flex justify-content-center align-items-center w-100">
                            Bio not found
                          </div>
                        )}
                      </div>
                    </div>
                  }
                  overlayClassName={`postCardDetails__popover ${
                    isDarkBackground ? "darkTheme" : "lightTheme"
                  }`}
                >
                  <Image
                    src={
                      postCardDetails?.ProfilePicture === 0 ||
                      postCardDetails?.ProfilePicture === "" ||
                      !postCardDetails?.ProfilePicture
                        ? Profile
                        : postCardDetails?.ProfilePicture
                    }
                    fallback={Profile}
                    preview={false}
                    alt="Profile Images"
                    className="authorImg authorImg--profile mr-0"
                  />
                </Popover>
              </div>
              <div style={{ width: "calc(100% - 0rem)" }}>
                <div className="authorName d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <Tooltip title={postCardDetails?.AuthorName}>
                      <span
                        className="text-ellipsis"
                        style={{ maxWidth: "15rem" }}
                      >
                        {postCardDetails?.AuthorName}
                      </span>
                    </Tooltip>

                    {postCardDetails?.AuthorIsVerified !== "NA" &&
                    postCardDetails?.AuthorIsVerified &&
                    postCardDetails?.AuthorIsVerified > 0 ? (
                      <img
                        src={verified}
                        alt="verified"
                        className="authorImg ml-1"
                        style={{ width: "1.5rem" }}
                      />
                    ) : (
                      ""
                    )}
                       {el?.isPromoted === 1 ? (
                              <Tooltip title="Boosted post">
                                <img
                                  alt="Boosted Post Icon"
                                  src={BoostedPostIcon}
                                  width="2rem"
                                  height="2rem"
                                  className="mr-0"
                                  style={{
                                                width: "2rem",
                                                height: "2rem",
                                              }}
                                />
                              </Tooltip>
                            ) : el?.isPromoted === 2 ? (
                              <Tooltip title="Ad post">
                                <img
                                  alt="Ad Post Icon"
                                  src={AdsPostIcon}
                                  width="2rem"
                                  height="2rem"
                                  className="mr-0"
                                  style={{
                                                width: "2rem",
                                                height: "2rem",
                                              }}
                                />
                              </Tooltip>
                            ) : (
                              ""
                            )}
                  </div>
                  <div className="position-relative">
                    <img
                      src={
                        postCardDetails?.ChannelGroupId === 0
                          ? Default_Brand
                          : SocialMedialogo?.[postCardDetails?.ChannelGroupId]
                          ? SocialMedialogo?.[postCardDetails?.ChannelGroupId]
                          : Default_Brand
                      }
                      style={{
                        width: "1.6rem",
                        maxHeight: "2rem",
                        // verticalAlign: "top",
                      }}
                      alt="channel icon"
                    />
                  </div>
                </div>

                <div
                  className="authorScreenName"
                  //style={{ maxWidth: "50%" }}
                >
                  {postCardDetails?.AuthorScreenName}
                </div>
              </div>
            </div>
            <div className="node-modal-body postCardDetails__body">
              <div className="d-flex align-items-center justify-content-between mb-1">
                {postCardDetails?.PlatformID === 1 ? (
                  <span className="mr-15 d-flex align-items-center no--wrap">
                    <Tooltip
                      title={
                        postCardDetails?.FollowersCount
                          ? postCardDetails?.FollowersCount?.toLocaleString()
                          : postCardDetails?.Followers?.toLocaleString()
                      }
                    >
                      <img
                        src={userFollowers}
                        className=" mr-1"
                        alt="userFollowers"
                      />
                      <span className="postCardDetails__footer--label">
                        Followers
                      </span>
                      <span className="postCardDetails__footer--count blue-text">
                        {postCardDetails?.FollowersCount
                          ? kFormatter(postCardDetails?.FollowersCount)
                          : kFormatter(postCardDetails?.Followers)}
                      </span>
                    </Tooltip>
                  </span>
                ) : (
                  ""
                )}
                <span
                  className="d-flex align-items-center"
                  style={{ maxWidth: "40%" }}
                >
                  <Tooltip
                    title={
                      <div>
                        Created Date : <br /> {postCardDetails?.CreatedDate}
                      </div>
                    }
                  >
                    <img
                      src={ClockIcon}
                      className="postCardDetails__footer--label mr-1"
                      alt="ClockIcon"
                    />
                    <span className="postCardDetails__footer--label">
                      {moment(postCardDetails?.CreatedDate)?.format(
                        "DD MMM YYYY"
                      )}
                    </span>
                  </Tooltip>
                </span>
              </div>
              <div className="postCardDetails--description">
                {postCardDetails?.Attachment?.length === 1 ? (
                  <div className="m-0 w-100 position-relative postCardDetails--image">
                    {postCardDetails?.Attachment?.map((imgUrl, index) => {
                      if (
                        imgUrl?.MediaType === "2" ||
                        imgUrl?.MediaType === "4"
                      ) {
                        return imgUrl ? (
                          <>
                            <Image
                              src={
                                imgUrl?.ThumbUrl ? imgUrl?.ThumbUrl : defaultImg
                              }
                              alt="Attachment Image"
                              style={{
                                borderRadius: "0.6rem",
                                objectFit: "cover",
                                height: "20rem",
                              }}
                              onError={onImageError}
                              className="border w-100"
                              fallback={defaultImg}
                              preview={!isImage}
                              placeholder={
                                <Image
                                  src={placeHolderImg}
                                  preview={false}
                                  className="position_relative w-100"
                                  style={{
                                    borderRadius: "3.2rem",
                                    objectFit: "cover",
                                    height: "20rem",
                                  }}
                                />
                              }
                            />
                          </>
                        ) : (
                          ""
                        );
                      } else if (
                        imgUrl?.MediaType === "3" ||
                        imgUrl?.MediaType === "7"
                      ) {
                        return imgUrl && !PdfDownloadStatus ? (
                          <>
                            {postCardDetails?.PlatformID === 2 ||
                            postCardDetails?.PlatformID === 4 ||
                            postCardDetails?.PlatformID === 37 ? (
                              <a
                                href={imgUrl?.MediaUrl ? imgUrl?.MediaUrl : ""}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <img
                                  src={
                                    imgUrl?.ThumbUrl
                                      ? imgUrl?.ThumbUrl
                                      : defaultImg
                                  }
                                  alt="Attachment Images"
                                  style={{
                                    width: "100%",
                                    objectFit: "cover",
                                    height: "20rem",
                                  }}
                                  onError={onImageError}
                                />
                                <div class="overlay-play-button__overlay">
                                  <div class="overlay-play-button__play">
                                    <i
                                      class="fa fa-play"
                                      style={{
                                        fontSize: "1.2rem",
                                        color: "#fff",
                                      }}
                                    ></i>
                                  </div>
                                </div>
                              </a>
                            ) : postCardDetails?.PlatformID === 1 ||
                              postCardDetails?.PlatformID === 3 ||
                              postCardDetails?.PlatformID === 37 ? (
                              <>
                                <div
                                  class="overlay-play-button"
                                  style={{ height: "20rem" }}
                                  onClick={() => handleVideoPreview(imgUrl)}
                                >
                                  <video
                                    width="100%"
                                    style={{
                                      objectFit: "cover",
                                      height: "20rem",
                                    }}
                                  >
                                    <source
                                      src={
                                        imgUrl?.MediaUrl
                                          ? imgUrl?.MediaUrl
                                          : defaultImg
                                      }
                                      type="video/mp4"
                                    />
                                  </video>

                                  <div class="overlay-play-button__overlay">
                                    <div class="overlay-play-button__play">
                                      <i
                                        class="fa fa-play"
                                        style={{
                                          fontSize: "1.2rem",
                                          color: "#fff",
                                        }}
                                      ></i>
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : (
                              ""
                            )}

                            // For Video Preview 
                            <VideoPreview
                              videoPreview={videoPreview}
                              setIsModalOpen={setIsVideoModalOpen}
                              isModalOpen={isVideoModalOpen}
                              isValidUrlFlag={isValidUrlFlag}
                            />
                          </>
                        ) : PdfDownloadStatus ? (
                          imgUrl && (
                            <img
                              src={imgUrl?.ThumbUrl}
                              alt="Attachment Images"
                              style={{
                                width: "8rem",
                                height: "6.6rem",
                              }}
                              onError={onImageError}
                            />
                          )
                        ) : (
                          ""
                        );
                      }
                    })}
                  </div>
                ) : (
                  postCardDetails?.Attachment?.length > 1 && (
                    <div className="w-100">
                      <Carousel
                        el={postCardDetails}
                        height="20rem"
                        postCardDetails={false}
                      />
                    </div>
                  )
                )}
                {postCardDetails?.PostText ? (
                  <div
                    className={`break-word mb-15 ${
                      postCardDetails?.Attachment?.length > 0 ? "mt-2" : ""
                    }`}
                  >
                    <a
                      className={
                        postCardDetails?.PostURL &&
                        postCardDetails?.PostURL?.trim() &&
                        postCardDetails?.PostURL !== "NA"
                          ? ""
                          : "pointer-events1 cursor-default"
                      }
                      href={
                        postCardDetails?.PostURL &&
                        postCardDetails?.PostURL?.trim() &&
                        postCardDetails?.PostURL !== "NA"
                          ? postCardDetails?.PostURL
                          : ""
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      {postCardDetails?.PostText || postCardDetails?.Title}
                    </a>
                  </div>
                ) : (
                  ""
                )}
                <PostCardFooter
                  data={postCardDetails}
                  isPreviewState={false}
                  PdfDownloadStatus={PdfDownloadStatus}
                  PptGeneratingStatus={false}
                  el={postCardDetails}
                  postDetail={true}
                  isReviewCard={false}
                  isNetworkTooltip={true}
                  isDarkBackground={isDarkBackground}
                />
                <div className="postCardDetails__footer pt-2 text-center border-top border-color">
                  <div className="mr-15" style={{ width: "25%" }}>
                    <div className="postCardDetails__footer--label white-space-nowrap">
                      Engagement
                    </div>
                    <div className="postCardDetails__footer--count font-size18 cursor-pointer line-height-normal">
                      <Tooltip title={postCardDetails?.Engagement}>
                        <div>{kFormatter(postCardDetails?.Engagement)}</div>
                      </Tooltip>

                      {postCardDetails?.engagement_fx ? (
                        <Tooltip title={postCardDetails?.Engagement_text}>
                          <img
                            src={fx}
                            style={{ maxWidth: "1.5rem" }}
                            className="mr-1 cursor-pointer"
                            alt="fx"
                          />
                        </Tooltip>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="mr-15" style={{ width: "25%" }}>
                    <div className="postCardDetails__footer--label white-space-nowrap cursor-pointer">
                      <Tooltip title="Engagement Rate">
                        <div className="white-space-nowrap">Eng. Rate</div>
                      </Tooltip>
                    </div>
                    <div className="postCardDetails__footer--count font-size18 cursor-pointer line-height-normal">
                      <Tooltip title={postCardDetails?.Engagement_rate}>
                        <div>
                          {kFormatter(postCardDetails?.Engagement_rate)}
                        </div>
                      </Tooltip>

                      <Tooltip title={postCardDetails?.Engagement_rate_text}>
                        <img
                          src={fx}
                          style={{ maxWidth: "1.5rem" }}
                          className="mr-1 cursor-pointer"
                          alt="fx"
                        />
                      </Tooltip>
                    </div>
                  </div>
                  <div className="mr-15" style={{ width: "25%" }}>
                    <div
                      className={`postCardDetails__footer--label d-inline-flex align-items-center ${
                        postCardDetails?.reach_fx ? "cursor-pointer" : ""
                      }`}
                    >
                      {postCardDetails?.reach_fx ? (
                        <Tooltip title="Estimated Reach">
                          <div className="white-space-nowrap">Est. Reach</div>
                        </Tooltip>
                      ) : (
                        <div className="white-space-nowrap">Reach</div>
                      )}
                      {postCardDetails?.reach_i && (
                        <Tooltip title="It looks like this video post has been watched by the same viewers multiple times.">
                          <img src={InfoIcon} alt="InfoIcon" className="ml-1" />
                        </Tooltip>
                      )}
                    </div>
                    <div className="postCardDetails__footer--count font-size18 cursor-pointer line-height-normal">
                      <Tooltip title={postCardDetails?.Reach}>
                        <div> {kFormatter(postCardDetails?.Reach)}</div>
                      </Tooltip>

                      {postCardDetails?.reach_fx && (
                        <Tooltip title="Number calculated from the formula provided in account section. Updates every midnight.">
                          <img
                            src={fx}
                            style={{ maxWidth: "1.5rem" }}
                            className="mr-1 cursor-pointer"
                            alt="fx"
                          />
                        </Tooltip>
                      )}
                    </div>
                  </div>
                  <div style={{ width: "25%" }}>
                    {postCardDetails?.impression_fx ? (
                      <Tooltip title="Estimated Impression">
                        <div className="postCardDetails__footer--label white-space-nowrap cursor-pointer">
                          {" "}
                          Est. Impression
                        </div>
                      </Tooltip>
                    ) : (
                      <div className="postCardDetails__footer--label white-space-nowrap">
                        Impression
                      </div>
                    )}
                    <div className="postCardDetails__footer--count font-size18 cursor-pointer line-height-normal">
                      <Tooltip title={postCardDetails?.Impression}>
                        <div>
                          {kFormatter(postCardDetails?.Impression, false, true)}
                        </div>
                      </Tooltip>

                      {postCardDetails?.impression_fx && (
                        <Tooltip title="Number calculated from the formula provided in account section. Updates every midnight.">
                          <img
                            src={fx}
                            style={{ maxWidth: "1.5rem" }}
                            className="mr-1 cursor-pointer"
                            alt="fx"
                          />
                        </Tooltip>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </>
      );
    } else if (authorDetails) {
      return (
        <>
          <div
            className={`node-modal-content authorDetails ${
              isDarkBackground || !dashboard ? "" : "border border-color"
            }`}
            style={{
              backgroundColor: bgColor,
              backgroundColor: bgColor,
              borderColor: data?.node?.color?.color,
            }}
          >
            <div
              className={`node-modal-arrow ${arrowDirection}`}
              style={
                arrowDirection === "top"
                  ? { borderTopColor: bgColor }
                  : arrowDirection === "bottom"
                  ? { borderBottomColor: bgColor }
                  : arrowDirection === "right"
                  ? { borderRightColor: bgColor }
                  : arrowDirection === "left"
                  ? { borderLeftColor: bgColor }
                  : ""
              }
            ></div>
            <div className="node-modal-header p-0 border-0 authorDetails__header">
              <div
                className="position-relative mr-15"
                style={{ width: "3.5rem", height: "3.5rem" }}
              >
                <Image
                  src={
                    authorDetails?.ProfilePicture === 0 ||
                    authorDetails?.ProfilePicture === "" ||
                    !authorDetails?.ProfilePicture
                      ? Profile
                      : authorDetails?.ProfilePicture
                  }
                  fallback={Profile}
                  preview={false}
                  alt="Profile Images"
                  className="authorImg authorImg--profile mr-0"
                />
              </div>
              <div style={{ width: "calc(100% - 0rem)" }}>
                <div className="authorName d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <Tooltip title={authorDetails?.AuthorName}>
                      <span
                        className="text-ellipsis"
                        style={{ maxWidth: "15rem" }}
                      >
                        {authorDetails?.AuthorName}
                      </span>
                    </Tooltip>

                    {authorDetails?.AuthorIsVerified !== "NA" &&
                    authorDetails?.AuthorIsVerified &&
                    authorDetails?.AuthorIsVerified > 0 ? (
                      <img
                        src={verified}
                        alt="verified"
                        className="authorImg ml-1"
                        style={{ width: "1.5rem" }}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div
                    className="position-relative"
                    // style={{ right: "-0.8rem", top: "-0.4rem" }}
                  >
                    <img
                      src={
                        authorDetails?.ChannelGroupId === 0
                          ? Default_Brand
                          : SocialMedialogo?.[authorDetails?.ChannelGroupId]
                          ? SocialMedialogo?.[authorDetails?.ChannelGroupId]
                          : Default_Brand
                      }
                      style={{
                        width: "1.6rem",
                        maxHeight: "2rem",
                        // verticalAlign: "top",
                      }}
                      alt="channel icon"
                    />
                  </div>
                </div>

                <div
                  className="authorScreenName"
                  //style={{ maxWidth: "50%" }}
                >
                  {authorDetails?.AuthorScreenName}
                </div>
              </div>

              {/* <span className="node-modal-title">{data?.title}</span>
              <button className="node-modal-close" onClick={closeModal}>
                ✖
              </button> */}
            </div>
            <div className="node-modal-body p-0">
              <div
                className="authorDetails--bio"
                style={{
                  minHeight: !authorDetails?.AuthorBio ? "inherit" : "",
                }}
              >
                {authorDetails?.AuthorBio ? (
                  <div className="authorDetails--bio--header font-weight500 w-100 mt-1">
                    Bio
                  </div>
                ) : (
                  ""
                )}

                {authorDetails?.AuthorBio ? (
                  <div className="break-word w-100">
                    <a
                      className={
                        authorDetails?.AuthorURL &&
                        authorDetails?.AuthorURL !== "NA"
                          ? ""
                          : "pointer-events1 cursor-default"
                      }
                      href={
                        authorDetails?.AuthorURL &&
                        authorDetails?.AuthorURL !== "NA"
                          ? authorDetails?.AuthorURL
                          : ""
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      {authorDetails?.AuthorBio}
                    </a>
                  </div>
                ) : (
                  <div className="d-flex justify-content-center align-items-center pt-15 pb-15 w-100">
                    Bio not found
                  </div>
                )}
              </div>
            </div>
            <div className="node-modal-footer p-0 border-0 mt-2">
              <div className="w-100 m-0 authorDetails__footer">
                <Tooltip title={authorDetails?.Followers?.toLocaleString()}>
                  <div className="authorDetails__footer--item">
                    <span className="authorDetails__footer--label">
                      Followers
                    </span>
                    <span className="authorDetails__footer--count">
                      {kFormatter(authorDetails?.Followers)}
                    </span>
                  </div>
                </Tooltip>

                {authorDetails?.Following ? (
                  <Tooltip title={authorDetails?.Following?.toLocaleString()}>
                    <div className="authorDetails__footer--item">
                      <span className="authorDetails__footer--label">
                        Following
                      </span>
                      <span className="authorDetails__footer--count">
                        {kFormatter(authorDetails?.Following)}
                      </span>
                    </div>
                  </Tooltip>
                ) : (
                  ""
                )}
                {authorDetails?.Engagement ? (
                  <Tooltip title={authorDetails?.Engagement?.toLocaleString()}>
                    <div className="authorDetails__footer--item">
                      <span className="authorDetails__footer--label">
                        Engagement/Post
                      </span>
                      <span className="authorDetails__footer--count">
                        {kFormatter(authorDetails?.Engagement)}
                      </span>
                    </div>
                  </Tooltip>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </>
      );
    } else {
      return null;
    }
  };
  if (!isTooltipShow || !tooltipData) return null;
  return (
    <div
      className={`network-node-tooltip-modal ${arrowDirection} ${
        isDarkBackground ? "dark-theme" : ""
      } ${yTranslatePercent > 50 ? "translate-y-100" : "translate-y-50"} ${
        xTranslatePercent < 50 ? "translate-x-0" : "translate-x-50"
      }`}
      style={{
        left: `${modalPosition.x}px`,
        top:
          arrowDirection === "bottom"
            ? `calc(${modalPosition.y}px + ${0}px`
            : `calc(${modalPosition.y}px - ${0}px`,
      }}
      ref={measuredTooltipRef}
    >
      {getTooltipCardData(tooltipData)}
    </div>
  );
};

// NetworkNodeTooltip.propTypes = {
//   tooltipData: PropTypes.object,
//   isTooltipShow: PropTypes.bool.isRequired,
//   setIsTooltipShow: PropTypes.func.isRequired,
// };

export default React.memo(NetworkNodeTooltip, isEqual);
